export default {
  // Header
  "title": "Générateur de Pokémon Aléatoire",
  "subtitle": "Générez des Pokémon aléatoires basés sur vos préférences",
  "home": "Accueil",
  "whichPokemonAmI": "Quel Pokémon suis-je ?",
  "aboutUs": "À propos",
  "contactUs": "Contact",
  "privacyPolicy": "Politique de confidentialité",
  
  // Filters
  "filterTitle": "Options de filtre",
  "generateButton": "Générer des Pokémon aléatoires",
  "generating": "Génération en cours...",
  "numberOfPokemon": "Nombre de Pokémon",
  "type": "Type",
  "generation": "Génération",
  "minimumRarity": "Rareté minimale (1-10)",
  "anyType": "Tout type",
  "anyGeneration": "Toute génération",
  "anyRarity": "Toute rareté",
  "countingPokemon": "Comptage des Pokémon correspondants",
  "matchingPokemonCount": "{{count}} Pokémon correspondent à vos filtres",
  
  // Pokemon Types
  "normal": "Normal",
  "fire": "Feu",
  "water": "Eau",
  "electric": "Électrik",
  "grass": "Plante",
  "ice": "Glace",
  "fighting": "Combat",
  "poison": "Poison",
  "ground": "Sol",
  "flying": "Vol",
  "psychic": "Psy",
  "bug": "Insecte",
  "rock": "Roche",
  "ghost": "Spectre",
  "dragon": "Dragon",
  "dark": "Ténèbres",
  "steel": "Acier",
  "fairy": "Fée",
  
  // Generations
  "Generation I": "Génération I",
  "Generation II": "Génération II",
  "Generation III": "Génération III",
  "Generation IV": "Génération IV",
  "Generation V": "Génération V",
  "Generation VI": "Génération VI",
  "Generation VII": "Génération VII",
  "Generation VIII": "Génération VIII",
  "Generation IX": "Génération IX",
  
  // Evolution Stage
  "evolutionStage": "Stade d'Évolution",
  "evolutionStageAll": "Tous les Stades",
  "evolutionStageFullyEvolved": "Pleinement Évolué",
  "evolutionStageNotFullyEvolved": "Pas Pleinement Évolué",
  
  // About Section
  "aboutTitle": "À propos du Générateur de Pokémon Aléatoire",
  
  // Section titles
  "introTitle": "Bienvenue sur notre Générateur de Pokémon Aléatoire",
  "howToUseTitle": "Comment utiliser le Générateur de Pokémon Aléatoire",
  "benefitsTitle": "Avantages de notre Générateur de Pokémon Aléatoire",
  "historyTitle": "Histoire de Pokémon",
  "popularPokemonTitle": "Pokémon populaires",
  "popularGamesTitle": "Jeux Pokémon populaires",
  "tradingContestsTitle": "Échanges et concours Pokémon",
  "faqTitle": "Questions fréquemment posées",
  "conclusionTitle": "Commencez votre aventure Pokémon aléatoire dès aujourd'hui !",
  
  // Footer
  "copyright": "© 2025 randompokemon.games",
  "trademark": "Pokémon et les noms des personnages Pokémon sont des marques déposées de Nintendo.",
  "linksTitle": "Liens utiles",
  
  // About Us Page
  "aboutUsTitle": "À propos de nous",
  "aboutUsWhoWeAre": "Qui sommes-nous",
  "aboutUsWhoWeAreContent1": "Bienvenue sur le Générateur de Pokémon Aléatoire, un outil créé par des fans passionnés de Pokémon. Notre aventure a commencé en 2023, lorsqu'un groupe de développeurs qui aimaient à la fois la programmation et Pokémon ont décidé de créer un outil utile pour la communauté.",
  "aboutUsWhoWeAreContent2": "Notre équipe est composée de développeurs, de designers et de créateurs de contenu qui travaillent ensemble pour offrir la meilleure expérience possible aux fans de Pokémon du monde entier.",
  "aboutUsOurMission": "Notre mission",
  "aboutUsOurMissionContent1": "Nous nous efforçons de rendre le monde de Pokémon plus accessible et plus agréable pour tous. Nos outils sont conçus pour aider les dresseurs à découvrir de nouveaux Pokémon, à créer des équipes équilibrées et à trouver leur Pokémon parfait.",
  "aboutUsOurMissionContent2": "Nous nous engageons à fournir une expérience conviviale, précise et divertissante qui respecte la franchise Pokémon tout en ajoutant de la valeur à la communauté.",
  "aboutUsOurTeam": "Notre équipe",
  "aboutUsOurTeamContent1": "Notre équipe diversifiée combine une expertise en développement web, connaissance de Pokémon, conception d'expérience utilisateur et gestion de communauté. Nous sommes unis par notre amour pour Pokémon et notre engagement à créer des outils de haute qualité.",
  "aboutUsOurTeamContent2": "Chaque membre de l'équipe contribue avec ses compétences et perspectives uniques pour faire du Générateur de Pokémon Aléatoire le meilleur outil possible.",
  "aboutUsJoinUs": "Rejoignez-nous",
  "aboutUsJoinUsContent": "Nous sommes toujours à la recherche de personnes passionnées pour rejoindre notre communauté. Que vous soyez développeur, designer, expert Pokémon ou simplement un utilisateur enthousiaste, vos commentaires et contributions sont les bienvenus.",
  
  // Contact Us Page
  "contactUsTitle": "Contact",
  "contactUsGetInTouch": "Prenez contact",
  "contactUsGetInTouchContent": "Vous avez des questions, des suggestions ou des commentaires sur le Générateur de Pokémon Aléatoire ? Nous aimerions avoir de vos nouvelles ! Voici comment vous pouvez contacter notre équipe.",
  "contactUsEmail": "Email",
  "contactUsPhone": "Téléphone",
  "contactUsAddress": "Adresse",
  "contactUsHelpSupport": "Aide & Support",
  "contactUsHelpSupportContent": "Besoin d'aide pour utiliser nos outils ou vous avez rencontré un problème ? Notre équipe de support est là pour vous aider.",
  "contactUsFAQ": "FAQ",
  "contactUsFAQContent": "Avant de nous contacter, consultez notre section FAQ qui couvre de nombreuses questions et problèmes courants.",
  "contactUsBugReport": "Signaler un bug",
  "contactUsBugReportContent": "Si vous avez trouvé un bug ou un problème technique, veuillez nous en informer par email avec 'RAPPORT DE BUG' dans la ligne d'objet.",
  
  // Privacy Policy Page
  "privacyPolicyTitle": "Politique de confidentialité",
  "privacyPolicyIntro": "Introduction",
  "privacyPolicyIntroContent": "Chez le Générateur de Pokémon Aléatoire, nous respectons votre vie privée et nous nous engageons à protéger vos données personnelles. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos informations lorsque vous utilisez notre site web.",
  "privacyPolicyInformation": "Informations que nous collectons",
  "privacyPolicyInformationContent": "Nous collectons des informations minimales pour fournir et améliorer nos services. Cela peut inclure :",
  "privacyPolicyInformationItem1": "Données d'utilisation (comme les pages visitées, le temps passé sur le site et les fonctionnalités utilisées)",
  "privacyPolicyInformationItem2": "Informations sur l'appareil (type de navigateur, système d'exploitation et résolution d'écran)",
  "privacyPolicyInformationItem3": "Adresse IP et localisation approximative (niveau pays uniquement)",
  "privacyPolicyCookies": "Cookies et technologies similaires",
  "privacyPolicyCookiesContent": "Nous utilisons des cookies pour améliorer votre expérience sur notre site web. Ces petits fichiers texte nous permettent de mémoriser vos préférences et d'analyser l'utilisation de notre site. Vous pouvez contrôler les cookies via les paramètres de votre navigateur.",
  "privacyPolicyThirdParty": "Services tiers",
  "privacyPolicyThirdPartyContent": "Notre site web peut utiliser des services tiers tels que des fournisseurs d'analyse et des réseaux de diffusion de contenu. Ces services peuvent collecter des informations sur votre utilisation de notre site web. Nous nous assurons que tous les tiers respectent votre vie privée et traitent les données de manière appropriée.",
  "privacyPolicySecurity": "Sécurité des données",
  "privacyPolicySecurityContent": "Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos informations contre tout accès, modification ou divulgation non autorisés. Cependant, aucune transmission sur Internet n'est 100% sécurisée, nous ne pouvons donc pas garantir une sécurité absolue.",
  "privacyPolicyChanges": "Modifications de cette politique",
  "privacyPolicyChangesContent": "Nous pouvons mettre à jour notre politique de confidentialité de temps à autre. Nous vous informerons des changements en publiant la nouvelle politique de confidentialité sur cette page et en mettant à jour la date de 'dernière mise à jour'.",
  "privacyPolicyContact": "Contactez-nous",
  "privacyPolicyContactContent": "Si vous avez des questions concernant cette politique de confidentialité, veuillez nous contacter via les informations fournies sur notre page de contact.",
  "privacyPolicyLastUpdated": "Dernière mise à jour",
  
  // Which Pokemon Am I Page
  "whichPokemonAmITitle": "Quel Pokémon suis-je ?",
  "whichPokemonAmISubtitle": "Découvrez quel Pokémon vous correspond le mieux",
  "enterYourName": "Entrez votre nom",
  "namePlaceholder": "Votre nom",
  "enterFavoriteColor": "Choisissez votre couleur préférée",
  "enterBirthMonth": "Choisissez votre mois de naissance",
  "selectBirthMonth": "Sélectionnez un mois",
  "enterPersonalityTrait": "Choisissez un trait de personnalité",
  "selectPersonalityTrait": "Sélectionnez un trait",
  "findMyPokemon": "Trouver mon Pokémon",
  "calculating": "Calcul en cours...",
  "yourPokemonIs": "Votre Pokémon est",
  "pokemonDescription": "Description",
  "personalityMatch": "Correspondance de personnalité",
  "yourCompatibility": "Votre compatibilité",
  "downloadImage": "Télécharger l'image",
  "shareResult": "Partager le résultat",
  "tryAgain": "Essayer à nouveau",
  "results": "Résultats",
  "aboutTool": "À propos de cet outil",
  "howToUse": "Comment l'utiliser",
  "benefits": "Avantages",
  "faq": "FAQ",
  "conclusion": "Conclusion",
  
  // Error messages
  "nameRequired": "Le nom est requis",
  "colorRequired": "Veuillez choisir une couleur",
  "monthRequired": "Veuillez choisir un mois",
  "traitRequired": "Veuillez choisir un trait de personnalité",
  
  // Months
  "january": "Janvier",
  "february": "Février",
  "march": "Mars",
  "april": "Avril",
  "may": "Mai",
  "june": "Juin",
  "july": "Juillet",
  "august": "Août",
  "september": "Septembre",
  "october": "Octobre",
  "november": "Novembre",
  "december": "Décembre",
  
  // Personality Traits
  "brave": "Brave",
  "calm": "Calme",
  "timid": "Timide",
  "jolly": "Jovial",
  "quiet": "Discret",
  "hasty": "Pressé",
  "careful": "Prudent",
  "lonely": "Solitaire",
  "bold": "Audacieux",
  "relaxed": "Détendu",
  "impish": "Espiègle",
  "modest": "Modeste",
  
  // Size matching feature
  "enterHeightWeight": "Entrez votre taille et votre poids — découvrez quel Pokémon vous correspond !",
  "whichPokemonMatchesSize": "Quel Pokémon correspond à votre taille ?",
  "youAreMostLike": "Vous ressemblez le plus à",
  "nameLabel": "Nom",
  "heightLabel": "Taille",
  "weightLabel": "Poids",
  "heightValid": "Veuillez saisir une taille valide (1-300 cm)",
  "weightValid": "Veuillez saisir un poids valide (1-500 kg)",
  "enterDetails": "Entrez vos détails",
  "finding": "Recherche en cours...",
  "errorFinding": "Erreur lors de la recherche de votre Pokémon",
  "matchResult": "Le Pokémon de {{name}} est...",
  "similarityScore": "Score de similitude",
  "downloadStarted": "Préparation de l'image...",
  "downloadComplete": "Image téléchargée avec succès !",
  "shareText": "J'ai découvert que je suis {{pokemon}} ! Découvrez quel Pokémon vous êtes !",
  "madeBy": "Créé par",

  // New Page: Pokemon Randomizer - About Section Titles (Translated to French)
  "pokemonRandomizerPageAboutTitle": "Découvrez l'Expérience Ultime du Randomiseur de Pokémon",
  "pokemonRandomizer_whatIsItTitle": "Qu'est-ce Qu'un Randomiseur de Pokémon Exactement ?",
  "pokemonRandomizer_featuresTitle": "Caractéristiques Clés de Notre Outil Randomiseur de Pokémon",
  "pokemonRandomizer_whyUseTitle": "Pourquoi Se Lancer Dans une Aventure avec un Randomiseur de Pokémon ?",
  "pokemonRandomizer_gettingStartedTitle": "Premiers Pas : Votre Première Partie avec le Randomiseur de Pokémon",
  "pokemonRandomizer_faqTitle": "Randomiseur de Pokémon : Questions Fréquemment Posées",

  // New keys for PokemonRandomizerPage.tsx H1 and subtitle (Translated to French)
  "pokemonRandomizerPageH1": "Randomiseur de Pokémon",
  "pokemonRandomizerPageSubtitle": "Créez des expériences Pokémon uniques avec notre outil de randomisation avancé.",

  // Sub-Footer
  subFooterToolsTitle: "Outils",
  subFooterRandomPokemonGeneratorLink: "Générateur de Pokémon Aléatoires",
  subFooterPokemonRandomizerLink: "Randomiseur de Pokémon",
  subFooterWhichPokemonAmILink: "Quel Pokémon Suis-Je ?",

  subFooterPokemonDatabaseTitle: "Base de Données Pokémon",
  subFooterPokedexLink: "Pokédex (Bientôt Disponible)",
  subFooterTypeChartsLink: "Tableaux des Types (Bientôt Disponible)",
  subFooterMoveListLink: "Liste des Capacités (Bientôt Disponible)",

  subFooterBlogTitle: "Blog",
  subFooterLatestArticlesLink: "Derniers Articles (Bientôt Disponible)",
  subFooterGuidesTutorialsLink: "Guides et Tutoriels (Bientôt Disponible)"
};
